import Icon from 'veui/components/Icon'
import { IconMobileApp } from 'dls-icons-vue'

Icon.register('mobile-app', IconMobileApp)
